<template>
  <div id="question">
    <van-list
      v-model="listLoading"
      :finished="finished"
      finished-text="没有更多数据了"
      @load="requestList"
      v-bind:callback="requestList"
    >
      <questionnaireListCard
        v-show="questionNaireAdministerList.length !== 0"
        :incomingList="questionNaireAdministerList"
      />
    </van-list>
  </div>
</template>

<script>
import questionnaireListCard from "@/pages/operationalAnalysis/components/QuestionnaireListCard.vue";

export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      questionNaireAdministerList: [],
      listLoading: false,
      finished: false,
      totalPages: 0 //总页数
    };
  },
  components: {
    questionnaireListCard
  },
  created: function() {},
  mounted: function() {},
  methods: {
    //请求数据
    async requestList() {
      this.xy.loading();
      let res = await this.xyapi.get(
        this.$store.state.apiPath + "/api/Questionnaire/GetPage",
        {
          searchText: "",
          pageIndex: this.page,
          pageSize: this.pageSize
        }
      );
      this.xy.unloading();
      if (res && res.data && res.data.data) {
        for (let i = 0; i < res.data.data.length; i++) {
          // console.log(newVal);
          if (res.data.data[i].PublishStauts === 0) {
            res.data.data[i].PublishStauts = false;
          } else {
            res.data.data[i].PublishStauts = true;
          }
        }
        this.totalPages = Math.ceil(res.data.totalRecords / this.pageSize); //总页数
        this.questionNaireAdministerList = [...this.questionNaireAdministerList,...res.data.data];
        // console.log(this.questionNaireAdministerList, this.totalPages);
        /* 单次请求数据完毕 */
        this.listLoading = false;
        if (this.page >= this.totalPages) {
          /* 所有数据加载完毕 */
          this.finished = true;
          return;
        }
        this.page++;
      } else {
        this.questionNaireAdministerList = [];
        this.finished = true;
        this.listLoading = false;
      }
    }
  }
};
</script>
<style lang='less' >
</style>